import {FREE_DOMAINS} from 'js/constants';

/**
 * validation
 */
export default class Validation {
  /**
   * required
   * @param {*} value
   * @return {boolean}
   */
  static required(value = null) {
    let result = false;

    if (null == value) {
      return reslut;
    }

    switch (typeof value) {
    case 'string':
      result = (0 < (value.trim()).length ? true : false);
      break;
    case 'object':
      result = (0 < (Object.keys(value)).length ? true : false);
      break;
    case 'boolean':
      result = value ? true : false;
      break;
    default:
      result = true;
      break;
    }

    return result;
  }

  /**
   * max
   * @param {*} value
   * @param {*} max
   * @return {boolean}
   */
  static max(value = null, max) {
    let result = false;

    switch (typeof value) {
    case 'string':
      result = (max >= value.length ? true : false);
      break;
    case 'number':
      result = (max >= value ? true : false);
      break;
    default:
      result = true;
      break;
    }

    return result;
  }

  /**
   * email format
   * @param {string} value
   * @return {boolean}
   */
  static email(value = null) {
    let result = false;

    const regex =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;

    if (regex.test(value)) {
      result = true;
    }

    return result;
  }

  /**
   * free domain
   * @param {string} value
   * @return {boolean}
   */
  static freeDomain(value = null) {
    let result = false;

    if (!value) {
      return false;
    }

    const email = value.trim().split('@');
    const domain1 = email[1];
    const domain2 = domain1.slice(domain1.indexOf('.') + 1);

    if (
      -1 == FREE_DOMAINS.indexOf(domain1) &&
      -1 == FREE_DOMAINS.indexOf(domain2)
    ) {
      result = true;
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/validation.js